import * as fcl from '@blocto/fcl'

export const subToTxStatus = (
  txId: string,
  retryLimit = 3,
  timeout = 60000 // 60 seconds
) => {
  return new Promise<any>((resolve, reject) => {
    let retryCount = 0
    const handleStatus = (response: {
      err?: any
      errorMessage?: string
      statusString?: string
    }) => {
      if (response.err) {
        console.error('ERR: ', response.err)
        // add papertrail (err, { extra: { txId, retryLimit } })
        if (retryCount < retryLimit) {
          retryCount++
          // console.log(`Retrying ${txId} (${retryCount}/${retryLimit})`)
          subToTxStatus(txId, retryLimit, timeout).then(resolve).catch(reject)
        } else {
          reject(response.err)
        }
      } else {
        if (response.statusString === 'SEALED' && !response.errorMessage) {
          resolve(response)
        } else if (response.errorMessage) {
          reject(
            new Error(
              `Transaction ${txId} failed with error: ${response.errorMessage}`
            )
          )
        }
      }
    }
    fcl.tx(txId).subscribe(handleStatus)
    setTimeout(() => {
      reject(new Error(`Transaction ${txId} timed out after ${timeout}ms`))
    }, timeout)
  })
}

export const waitForSealed = async (txId: string) => {
  const status = await subToTxStatus(txId, 3, 60000)
  if (status.statusString !== 'SEALED') {
    throw new Error(
      `Transaction ${txId} failed with status: ${status.statusString}`
    )
  }
}
